<template>
  <div class="table-container">
    <v-data-table
      :headers="tableHeaders"
      :items="items"
      item-key="id"
      :show-select="false"
      :disable-pagination="true"
      hide-default-header
      :hide-default-footer="true"
    >
      <template v-slot:header>
        <thead>
          <tr>
            <th v-for="(s, index) in tableHeaders" :key="index">
              <div style="margin-left: 24px" v-if="s.text == 'Название'">
                {{ s.text }}
              </div>

              <div v-else>
                {{ s.text }}
              </div>
            </th>
          </tr>
        </thead>
      </template>
      <template v-slot:body="props">
        <draggable
          :list="sortedItems"
          tag="tbody"
          @end="endDrag"
          :move="checkMove"
          :style="moveItems ? 'pointer-events: none;' : ''"
        >
          <tr
            v-for="(item, index) in sortedItems"
            :key="index"
            :style="item.position == 1 ? 'pointer-events: none;' : ''"
            @click="goToEdit(item)"
          >
            <td
              style="min-width: 34px !important ; padding: 18px 12px 18px 12px"
            >
              <div class="td-expert-fullname">
                <v-icon
                  v-if="item.position != 1"
                  small
                  style="cursor: pointer"
                  :disabled="moveItems ? true : false"
                >
                  mdi-menu
                </v-icon>
              </div>
            </td>
            <td
              style="min-width: 162px !important; padding: 18px 15px 18px 15px"
            >
              <div class="td-expert-fullname">{{ item.index }}</div>
            </td>
            <td
              style="min-width: 279px !important; padding: 18px 15px 18px 15px"
            >
              {{ item.title }}
            </td>
            <td
              style="min-width: 375px !important; padding: 18px 15px 18px 15px"
            >
              <div class="td-expert-fullname">
                {{ item.link }}
              </div>
            </td>
            <td
              style="min-width: 150px !important; padding: 18px 15px 18px 15px"
            >
              <div class="td-expert-fullname">
                {{ item.sharesAmount }}
              </div>
            </td>
          </tr>
        </draggable>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
  },
  props: {
    tableHeaders: {
      type: Array,
    },
    items: {
      type: Array,
    },
  },

  data: () => ({
    moveItems: false,
    selectedDrag: "",
  }),
  computed: {
    sortedItems() {
      return this.items.sort((a, b) => a.index - b.index);
    },
  },
  methods: {
    getListPrivilegies() {
      this.$axios
        .get(this.$store.getters.apiAdminPanelV5 + "/privileges", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
            "secret-key": this.$store.state.secretKeyCookie,
          },
        })
        .then((res) => {
          this.items = res.data;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    goToEdit(item) {
      this.$emit("goToEdit", item);
    },
    endDrag(evt) {
      this.moveItems = true;
      this.$axios
        .patch(
          this.$store.getters.apiAdminPanelV5 + "/privileges/sort",
          {
            id: this.selectedDrag,
            index: evt.newIndex + 1,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then(() => {
          this.moveItems = false;
          this.getListPrivilegies();
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
          this.moveItems = false;
        });
    },
    checkMove(evt) {
      this.selectedDrag = evt.draggedContext.element.id;
    },
  },
};
</script>

<style scoped lang="scss">
.circleStatusOnline {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(0, 128, 0, 0.649);
}
.circleStatusOffline {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(255, 0, 0, 0.642);
}
.table-container {
  height: calc(100vh - 190px);
  overflow: auto;
}

.td-expert-fullname {
  display: flex;
  height: 100%;
  align-items: flex-start;
  justify-content: flex-start;

  .photo-expert {
    margin-right: 10px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }
}
</style>
